const libMethodMapping = {
	nameplate: 'ActionNameplateT3',
	vehicleView: 'SpecificVehicleViewT3'
};

const actionMapping = {
	browseGallery: 'BrowseGalleryT3',
	modelClick: 'SIResultsT3',
	myCarsAlerts: 'GetAlertsT3',
	myCarsSave: 'SaveSIT3',
	pageLoad: 'SVVSIT3',
	windowsticker: 'ViewWindowSticker'
};

export default {
	events: {
		'ddc.wstagging.first': [
			{
				note: 'need this to trigger the stuff that loads the script',
				payload: {}
			}
		],
		'ddc.page.view': [
			{
				logic: () => {
					const { isVdp, pageName } =
						window.DDC.dataLayer.page.pageInfo;

					return isVdp && pageName.includes('NEW');
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.initData]]',
						'[[mapping.configuration.sharedPayloads.initDataVdp]]'
					],
					libMethod: libMethodMapping.vehicleView,
					action: actionMapping.pageLoad
				}
			}
		],
		'ddc.link.hproductClick': [
			{
				logic: {
					'eventData.type': 'new'
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.initData]]'
					],
					libMethod: libMethodMapping.nameplate,
					action: actionMapping.modelClick,
					year: '[[eventData.year]]',
					brand: '[[eventData.make]]',
					nameplate: '[[eventData.make]] [[eventData.model]]'
				}
			}
		],
		widgetUserEvent: [
			{
				logic: {
					'eventData.widgetName': 'ws-vehicle-media'
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.initData]]',
						'[[mapping.configuration.sharedPayloads.initDataVdp]]'
					],
					libMethod: libMethodMapping.vehicleView,
					action: actionMapping.browseGallery
				}
			},
			{
				logic: {
					'eventData.widgetName': 'ws-vehicle-gallery'
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.initData]]',
						'[[mapping.configuration.sharedPayloads.initDataVdp]]'
					],
					libMethod: libMethodMapping.vehicleView,
					action: actionMapping.browseGallery
				}
			},
			{
				logic: {
					'eventData.widgetName': 'ws-mycars-vdp',
					'eventData.result': 'Vehicle saved'
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.initData]]',
						'[[mapping.configuration.sharedPayloads.initDataVdp]]'
					],
					libMethod: libMethodMapping.vehicleView,
					action: actionMapping.myCarsSave
				}
			},
			{
				logic: {
					'eventData.widgetName': 'ws-inv-listing',
					'eventData.result': 'Vehicle saved'
				},
				payload: ({ eventData }) => ({
					shared: [
						'[[mapping.configuration.sharedPayloads.initData]]',
						'[[mapping.configuration.sharedPayloads.initDataVdp]]'
					],
					year: eventData.vehicle.year,
					libMethod: libMethodMapping.vehicleView,
					action: actionMapping.myCarsSave
				})
			},
			{
				logic: {
					'eventData.widgetName': 'ws-mycars-vdp',
					'eventData.result':
						'Email Signup for Price Alert Notifications'
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.initData]]',
						'[[mapping.configuration.sharedPayloads.initDataVdp]]'
					],
					libMethod: libMethodMapping.vehicleView,
					action: actionMapping.myCarsAlerts
				}
			},
			{
				logic: {
					'eventData.widgetName': 'ws-inv-listing',
					'eventData.result':
						'Email Signup for Price Alert Notifications'
				},
				payload: ({ eventData }) => ({
					shared: [
						'[[mapping.configuration.sharedPayloads.initData]]',
						'[[mapping.configuration.sharedPayloads.initDataVdp]]'
					],
					year: eventData.vehicle.year,
					libMethod: libMethodMapping.vehicleView,
					action: actionMapping.myCarsAlerts
				})
			},
			{
				logic: ({ eventData: { isWindowStickerLink } }) =>
					isWindowStickerLink,
				payload: ({ eventData: { vehicle } }) => {
					return {
						shared: [
							'[[mapping.configuration.sharedPayloads.initData]]'
						],
						libMethod: libMethodMapping.vehicleView,
						action: actionMapping.windowsticker,
						uid: vehicle?.vin,
						year: vehicle?.year,
						brand: vehicle?.make,
						nameplate: vehicle?.model,
						trim: vehicle?.trim
					};
				}
			}
		],
		'ddc.link.generic': [
			{
				logic: ({ eventData }) => {
					return (
						eventData?.url
							?.toLowerCase?.()
							.includes('windowsticker') &&
						window?.DDC?.dataLayer?.page?.pageInfo?.isVlp &&
						window?.DDC?.dataLayer?.page?.pageInfo?.pageName?.includes?.(
							'_NEW'
						) &&
						!eventData?.attributes?.class.includes(
							'window-sticker-link'
						)
					);
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.initData]]'
					],
					libMethod: libMethodMapping.vehicleView,
					action: actionMapping.windowsticker,
					uid: '[[eventData.vehicle.vin]]',
					year: '[[eventData.vehicle.modelYear]]',
					brand: '[[eventData.vehicle.make]]',
					nameplate: '[[eventData.vehicle.model]]',
					trim: '[[eventData.vehicle.trim]]'
				}
			}
		],
		'ddc.form.initiation': [
			{
				logic: {
					mustInclude: {
						'DDC.dataLayer.page.pageInfo.pageName': 'NEW_DETAILS'
					},
					mustExist:
						'[[mapping.form.formInitMapping.[[eventData.trackingId]]]]'
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.initData]]',
						'[[mapping.configuration.sharedPayloads.initDataVdp]]'
					],
					libMethod: libMethodMapping.vehicleView,
					action: '[[mapping.form.formInitMapping.[[eventData.trackingId]].action]]'
				}
			}
		],
		'ddc.form.submission': [
			{
				logic: {
					mustInclude: {
						'DDC.dataLayer.page.pageInfo.pageName': [
							'NEW',
							'INVENTORY'
						]
					},
					mustExist:
						'[[mapping.form.formConfirmMapping.[[eventData.trackingId]]]]'
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.initData]]',
						'[[mapping.configuration.sharedPayloads.initDataVdp]]'
					],
					libMethod: libMethodMapping.vehicleView,
					action: '[[mapping.form.formConfirmMapping.[[eventData.trackingId]].action]]'
				}
			}
		],
		'ddc.form.confirmation': [
			{
				logic: {
					mustExist:
						'[[mapping.form.formConfirmMapping.[[eventData.trackingId]]]]'
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.initData]]',
						'[[mapping.configuration.sharedPayloads.initDataVdp]]'
					],
					libMethod: libMethodMapping.vehicleView,
					action: '[[mapping.form.formConfirmMapping.[[eventData.trackingId]].action]]'
				}
			}
		]
	}
};
